// 404Page.js
import React from "react";
import "./404Page.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


const Bubble = ({ className, style }) => {
    return <div className={`bubble ${className}`} style={style}></div>;
};

const NotFoundPage = () => {
    const navigate = useNavigate();

    const { t } = useTranslation("header");

    const handleNavigate = () => {
        navigate('/');
    }
    return (
        <>
            <div className="container">
                <div className="not-found-container">

                    {[...Array(5)].map((_, index) => (
                        <Bubble key={index} className={`bubble-${index + 1}`} />
                    ))}
                    <div className="main">
                        <h1>404</h1>
                        <p className="mb-4">
                            {t("page_not_found")}<br />
                            {" "}
                        </p>
                        <button type="button" className="btn btn-primary" onClick={handleNavigate}>
                        {t("go_back")}
                        </button>
                    </div>
                </div>
            </div>

        </>
    );
};

export default NotFoundPage;
